import { render } from "./MfaSetupView.vue?vue&type=template&id=03cf2ea2"
import script from "./MfaSetupView.vue?vue&type=script&lang=js"
export * from "./MfaSetupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__